import { withStyles } from '@material-ui/styles';

// ----------------------------------------------------------------------

const GlobalStyles = withStyles((theme) => ({
  '@global': {
    '*': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box'
    },
    html: {
      width: '100%',
      height: '100%',
      '-ms-text-size-adjust': '100%',
      '-webkit-overflow-scrolling': 'touch'
    },
    body: {
      width: '100%',
      height: '100%'
    },
    '#root': {
      width: '100%',
      height: '100%',
    },

    // ✅ TEST PRINT STYLE
    '@media print': {
      '@global': {
        'body': {
          margin: 0,
          padding: 0,
          overflow: 'visible',
        },
        '*': {
          pageBreakInside: 'avoid !important',
          breakInside: 'avoid !important',
        }
      }
    },

    ".a2Print": {
      pageBreakBefore: "auto !important",
      pageBreakAfter: "auto !important",
      pageBreakInside: "avoid !important",
    },

    // '@page': {
    //   size: '210mm auto', // Custom A4 width, height based on content
    //   margin: '10mm'
    // },

    '.ql-toolbar.ql-snow': {
      borderTopLeftRadius: '5px',
      borderTopRightRadius: '5px',
      display: 'flex',
      justifyContent: 'flex-end'
    },

    '.ql-container.ql-snow': {
      borderBottomLeftRadius: '5px',
      borderBottomRightRadius: '5px',
    },

    '.ql-editor.ql-blank::before': {
      color: theme.palette.mode === 'light' ? 'black !important' : 'white !important'
    },

    input: {
      '&[type=number]': {
        MozAppearance: 'textfield',
        '&::-webkit-outer-spin-button': { margin: 0, WebkitAppearance: 'none' },
        '&::-webkit-inner-spin-button': { margin: 0, WebkitAppearance: 'none' }
      }
    },
    textarea: {
      '&::-webkit-input-placeholder': { color: theme.palette.text.disabled },
      '&::-moz-placeholder': { opacity: 1, color: theme.palette.text.disabled },
      '&:-ms-input-placeholder': { color: theme.palette.text.disabled },
      '&::placeholder': { color: theme.palette.text.disabled }
    },
    a: { color: theme.palette.primary.main },
    img: { display: 'block', maxWidth: '100%' },

    // Lazy Load Img
    '.blur-up': {
      WebkitFilter: 'blur(5px)',
      filter: 'blur(5px)',
      transition: 'filter 400ms, -webkit-filter 400ms'
    },
    '.blur-up.lazyloaded ': {
      WebkitFilter: 'blur(0)',
      filter: 'blur(0)'
    }
  }
}))(() => null);

export default GlobalStyles;
